import { FC } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../../../../../api/generated';
import { KendoLoading } from '../../../../../../components';
import ListItemCreateButton from '../../../../../../components/custom/ListItemCreateButton';
import { useConfirmation } from '../../../../../../components/dialogs';
import { usePageableGrid } from '../../../../../../components/hooks/usePageableGrid';
import { GridColumn } from '../../../../../../components/KendoReact/Grid';
import { Grid } from '../../../../../../components/KendoReact/Grid/Grid';
import { useWindow } from '../../../../../../components/windows/WindowContext';
import AdministrationActionCell from '../../../components/AdministrationActionCell';
import { ISettings } from '../../GeneralSettingsPage';
import UserWarningOfDevicesEmailCreateWindow from './UserWarningOfDevicesEmailCreateWindow';

interface IProps {
    settings: ISettings | null;
    fetchData: () => Promise<void>;
}

export const GeneralSettingsUsersWarningOfDevices: FC<IProps> = (props) => {
    const { confirmAsync } = useConfirmation();
    const { openWindow } = useWindow();
    const [gridPageProps] = usePageableGrid([5, 10, 15, 20, 25], 15);

    const openUserWarningOfDevicesEmailCreateWindow = async () => {
        try {
            UserWarningOfDevicesEmailCreateWindow.defaultProps = {
                componentProps: {
                    fetchData: props.fetchData
                }
            };
            openWindow({
                title: 'Sukurti įrašą įspėjimui apie įrangos trikdžius',
                component: UserWarningOfDevicesEmailCreateWindow,
                isDialogBehaviour: true,
                width: 800,
                height: 400
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    const handleDelete = async (id: number) => {
        try {
            const { success } = await confirmAsync('El. pašto ištrynimas', 'Ar tikrai norite ištrinti pasirinktą el. paštą?');

            if (!success) {
                return;
            }
            await api.administration.deleteUserWarningDevicesEmail(id);
            props.fetchData();
            toast.success('El. paštas sėkmingai ištrintas');
        } catch (ex) {
            toast.error('El. pašto ištrinti nepavyko, sistemos klaida');
        }
    };

    return (
        <>
            {!props.settings && <KendoLoading />}
            {props.settings && (
                <div className="ms-Grid" dir="ltr">
                    <ListItemCreateButton openCreateModal={openUserWarningOfDevicesEmailCreateWindow} />

                    <Grid className="mt-2" {...gridPageProps} data={props.settings.usersWarningOfDevicesEmails}>
                        <GridColumn
                            width={100}
                            title="Veiksmai"
                            cell={(c) => <AdministrationActionCell {...c} fetchData={props.fetchData} deleteItem={handleDelete} editItem={null} />}
                        />
                        <GridColumn title="El. paštas" field="email" />
                    </Grid>
                </div>
            )}
        </>
    );
};
